import SearchBar from "./SearchBar";

interface HeroProps {
  onSearch: (searchTerm: string) => void;
}

const Hero = ({ onSearch }: HeroProps) => {
  return (
    <section className="bg-hackGreen-100 py-12 md:py-20 text-center">
      <div className="container mx-auto px-4">
        <h1 
          className="text-3xl md:text-5xl font-bold mb-4 md:mb-6 max-w-4xl mx-auto text-gray-900"
          style={{ fontFamily: 'Nunito Sans, sans-serif' }}
        >
          Discover Innovative Hacks for Everyday Accessibility
        </h1>
        <p 
          className="text-lg md:text-xl text-gray-700 mb-6 md:mb-10 max-w-3xl mx-auto"
          style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 400 }}
        >
          Explore a wide range of community-driven hacks designed to improve accessibility 
          in daily life. Join us in sharing, voting, and improving the tools that empower everyone.
        </p>
        <div className="max-w-3xl mx-auto">
          <SearchBar onSearch={onSearch} />
        </div>
      </div>
    </section>
  );
};

export default Hero;
